module.exports = __webpack_public_path__ + "media/images/logo1-21a8abad234496593caf211fc7f722c9.svg";